import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { GetProposalService } from "../../services/get-proposal.service";
import { MatDialog } from "@angular/material/dialog";
import { ModalComponent } from "../modal/modal.component";
import { MessageService } from "../../services/message.service";
import { CommonService } from "../../services/common.service";

@Component({
  selector: "app-tags-mapped-projects",
  templateUrl: "./tags-mapped-projects.component.html",
  styleUrls: ["./tags-mapped-projects.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class TagMappedProjectsComponent implements OnInit {
  opportunityId: any;
  projects: any = [];
  loading = false;
  user: any;
  activeHubbleInsight: boolean = false;
  observer: any;
  displayLabels: any;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly proposalService: GetProposalService,
    private readonly dialog: MatDialog,
    private readonly router: Router,
    private readonly messageService: MessageService,
    private readonly commonService: CommonService,
  ) {}

  ngOnInit(): void {
    this.displayLabels = this.commonService.getLabels();
    this.user = JSON.parse(localStorage.getItem("permission") ?? "{}");
    const fullPath = this.router.url;
    this.messageService.setHubbleInsightVendor([]);
    this.observer = this.messageService
      .getHubbleInsightVendor()
      .subscribe((vendors: any) => {
        if (
          vendors?.length &&
          (fullPath.endsWith("opportunity/distribution") ||
            fullPath.endsWith("proposal-evaluation"))
        ) {
          this.activeHubbleInsight = true;
        } else {
          this.activeHubbleInsight = false;
        }
      });
    this.route.params.subscribe((res: any) => {
      this.opportunityId = atob(res.id);
      this.getOpportunityMappedProjects();
    });
  }

  getOpportunityMappedProjects() {
    this.loading = true;
    this.proposalService
      .getMappedProjects(this.opportunityId)
      .subscribe((res: any) => {
        this.loading = false;
        this.projects = res;
        this.projects.forEach((element: any) => {
          element.color = this.getGMapRandomColor();
        });
      });
  }

  getGMapRandomColor() {
    const colorNum = 360;
    const color = Math.floor(Math.random() * colorNum);
    return `hsla(${color}, 30%, 75%, 100%)`;
  }

  openProjects(res: any) {
    const newitem = {
      project_id: res.id,
      program_name: res.projectprograms__program__name,
      program_id: res.projectprograms__program,
      subportfolio_name: res.sub_portfolio,
      subportfolio_id: res.sub_portfolio_id,
      portfolio_name: res.portfolio,
      portfolio_id: res.portfolio_id,
      manager: res.owner_name,
    };
    localStorage.setItem("program", JSON.stringify(newitem));

    this.dialog.closeAll();
    const dialog = this.dialog.open(ModalComponent, {
      hasBackdrop: true,
      disableClose: true,
      autoFocus: false,
      width: "80vw",
      data: {
        opportunity: res.id,
      },
    });
    dialog.componentInstance.type = { name: "projectpop" };
    dialog.afterClosed().subscribe((data: any) => {
      if (data) {
        window.location.href = data.replace("embedded=true", "");
      }
    });
  }
  ngOnDestroy(): void {
    if (this.observer) {
      this.observer.unsubscribe();
    }
  }
}
